/** The `attributes` area: the laneable attributes and their values
 *  (src/domain/lane-attributes.ts), the words a board lanes by, a list groups
 *  by and a state chip's menu offers. */
export const attributes = {
  /** Each attribute's own name: the question its values answer. */
  'attributes.name.active': 'Activity',
  'attributes.name.closed': 'Conclusion',
  'attributes.name.delivered': 'Completion',
  'attributes.name.verdict': 'Verdict',
  // The values, by attribute.
  'attributes.value.active.no': 'Idle',
  'attributes.value.active.yes': 'Active',
  'attributes.value.closed.no': 'Open',
  /** The conclusion with the work done, and without it (domain/tags.ts
   *  `lifecycleReading`): the conclusion axis's three values. */
  'attributes.value.closed.yes': 'Done',
  'attributes.value.closed.cancelled': 'Cancelled',
  /** The completion axis: the work is not done yet, or it is handed in (in
   *  review, or done). */
  'attributes.value.delivered.no': 'Not done',
  'attributes.value.delivered.yes': 'Done or in review',
  'attributes.value.verdict.none': 'Open',
  'attributes.value.verdict.accepted': 'Accepted',
  'attributes.value.verdict.disputed': 'Denied',
  /** A section's or a lane's heading: the attribute and the value, "Activity: Idle". */
  'attributes.heading': '{attribute}: {value}',
  // A stage's `means` pair in plain words (domain/stage-gates.ts
  // `describeMeansPair`): a spec line, a stage's sub-line, an example state.
  'attributes.pair.delivered': 'Completion: {value}',
  'attributes.pair.closed': 'Conclusion: {value}',
  /** A stage's conclusion read as the ending it brings (`describeMeans`,
   *  2026-11-03): what the stage DOES, in the words the item then wears. */
  'attributes.pair.position.done': 'Done',
  'attributes.pair.position.cancelled': 'Cancelled',
  'attributes.pair.active': 'Active: {value}',
  'attributes.pair.yes': 'yes',
  'attributes.pair.no': 'no',
  'attributes.pair.verdict.none': 'Verdict: none yet',
  'attributes.pair.verdict.accepted': 'Verdict: Accepted',
  'attributes.pair.verdict.disputed': 'Verdict: Denied',
  /** A health state worn or cleared: "Blocked: worn". */
  'attributes.pair.signal.worn': '{signal}: worn',
  'attributes.pair.signal.clear': '{signal}: clear',
  'attributes.pair.field': '{field}: {value}',
  'attributes.pair.field.empty': '{field}: empty',
  /** An example state's field holding none of the values the words name. */
  'attributes.pair.field.other': '{field}: any other value',
  /** Pairs side by side. */
  'attributes.pair.joined': '{first} · {second}',
} as const;
